import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { EmailMessage } from 'src/app/components/email-queue/email-message';
import { EmailQueueService } from 'src/app/services/email-queue-service';

@Component({
    selector: 'app-email-queue-view',
    templateUrl: './email-queue-view.component.html',
    styleUrls: ['./email-queue-view.component.scss'],
    standalone: false
})
export class EmailQueueViewComponent implements OnInit {
  constructor(
    private emailQueueService: EmailQueueService,
    private route: ActivatedRoute
  ) { }

  emailMessageId: string = '';
  emailMessage: EmailMessage | undefined;
  pageName=CheckPageAccess.EMAILQUEUE

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.emailMessageId = params['id'];
    });
    this.emailQueueService.getEmailQueueView(this.emailMessageId).subscribe({
      next: (response) => {
        this.emailMessage = response;
      },
      error: (errorMessage) => {
        console.log('Error:' + errorMessage)
      },
      complete: () => { }
    });
  }
}